import { useEffect } from 'react';
import { useRouter } from 'next/router';

const useForceHardReload = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      const currentPath = router.asPath.split('?')[0];

      if (currentPath.includes('/elearningcenter/')) {
        // Force a hard reload to the target URL (no DOM mutations from scripts)
        window.location.href = url;

        // Throw an error to abort the Next.js client-side transition
        // This prevents the soft-navigation from flashing before the reload happens.
        // You will see a "Route Cancelled" error in the console, which is expected.
        throw new Error('Route Cancelled: Full reload requested');
      }
    };

    router.events.on('routeChangeStart', handleRouteChange);

    // Cleanup subscription on unmount
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router]);
};

export default useForceHardReload;
